export default "__VITE_ASSET__D070jIrd__"